export default __webpack_public_path__ + "static/Economic Model Whitepaper - French-124f89bf8ba5746ecfe4edc1d0bdd740.pdf";